import React, {useEffect, useState} from 'react';

function UseNetwork () {
    const [state, setState] = useState({
        since: undefined,
        online: navigator.onLine
    });

    useEffect(() => {

        const handleOnline = () => {
            setState((prev: any) => ({
                ...prev,
                online: true,
                since: new Date().toString()
            }))
        };

        const handleOffline = () => {
            setState((prev: any) => ({
                ...prev,
                online: false,
                since: new Date().toString()
            }))
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline)
        }
    }, []);

    return state
};

export default UseNetwork;